
import { defineComponent, PropType } from '@vue/runtime-core'
import Button from '@/components/elements/Button.vue'
import HeadingLv2 from '@/components/elements/HeadingLv2.vue'
import HeadingLv3 from '@/components/elements/HeadingLv3.vue'
import Checklist from '@/components/block/Checklist.vue'
import SeminarCassette from '@/components/block/SeminarCassette.vue'
import SeminarLecturer from '@/components/block/SeminarLecturer.vue'
import dayjs from 'dayjs'
import 'dayjs/locale/ja'
dayjs.locale('ja')

interface Movie {
  type: string
  id: string
  thumb: string
  label: string[]
  title: string
  description: string
}
interface Seminar {
  title: string
  finish: boolean
  term: {
    start: string
    end: string
  }
  description: string
  howto: string
  capacity: string
  time: string
  lecturer: any[]
  movie: Movie[]
  program_id: string
}

export default defineComponent({
  name: 'EventDetailSeminars',

  components: {
    Button,
    HeadingLv2,
    HeadingLv3,
    SeminarLecturer,
    Checklist,
    SeminarCassette
  },

  props: {
    seminars: {
      type: Array as PropType<Seminar[]>,
      default: () => []
    },
    isArchived: {
      type: Boolean,
      required: true
    },
    openModal: {
      type: Function as PropType<(movies: any, title: string) => void>
    }
  },

  setup() {
    const getDateToTime = (date: string) =>
      dayjs(date).format('YYYY年M月D日（ddd）H時mm分')

    const isFinish = (seminar: Seminar) => {
      const isExpired = dayjs().isAfter(dayjs(seminar.term.end))
      return seminar.finish || isExpired
    }

    return {
      getDateToTime,
      isFinish
    }
  }
})
